<!-- VizletHeader.vue -->
<template>
  <div class="d-flex justify-content-between p-1">
    <div class="mr-auto d-flex align-items-center" v-if="vizCount!==1">
      <i style="margin-right: 10px"
         :class="viz1.vizlet_title_info ? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
         ref="tooltipIcon"
         v-b-tooltip.hover.right.html="{ title: viz1.vizlet_title_info, customClass: 'my-custom-tooltip1', autoHide: false }"
         @mouseenter="showTooltip"
         @mouseleave="hideTooltip"/>
      <span v-if="$store.state.deviceType !== 'Mobile'">{{ viz1.vizletTitleDpName }}</span>
      <i v-if="viz1.insight_navigator && viz1.insight_navigator.navList.length>0" class="fas fa-book-reader"
         style="margin-left: 10px;color: #6495ED;"></i>
    </div>

    <div v-show="viz1.vizletMiddleTitleFlag" class="mr-auto p-2" style="font-size: 30px;font-weight: bold" v-if="vizCount!==1">
      <span v-show="format(total)">{{ viz1.vizletTitleMiddleName }} : {{ format(total) }}</span>
    </div>

    <div v-if="(viz1.viztypeName === 'TableBar' || viz1.viztypeName === 'Tabulator')"
         style="margin-top: -2px;margin-right: 10px">
      <input type="text" placeholder="Search..." v-model="localSearchQuery"
             @input="handleSearchInput"
             class="form-control form-control-sm"/>
    </div>

    <div v-if="$store.state.deviceType === 'Mobile'">
      <span @click="$emit('toggle-body')" :title="isCollapsed ? 'Expand' : 'Collapse'">
        <i class="fas" :class="isCollapsed ? 'fa-caret-square-down' : 'fa-caret-square-up'"></i>
      </span>

      <span v-for="(ai,index) in mCurrentMenuActionIconsData" :key="'m-'+index">
        <span @click="$emit('action', ai.functionName, index, ai)">
          <i :id="ai.iconId"
             :class="[iconOnChangeFlag[index] === true ? ai.iconClass : ai.iconOnchangeClass]"
             :title="iconOnChangeFlag[index] ? ai.iconTooltip : ai.iconOnchangeTooltip"
             style="font-size:15px; padding-left:10px;"></i>
        </span>
      </span>
    </div>

    <div v-else>
      <span v-if="viz1.viztypeName === 'TableBar'" title="Clear Filter" @click="$emit('reset-filter')">
        <i class="fas fa-solid fa-filter"></i>
      </span>

      <span v-if="vizCount === 1" style="margin: 10px" :title="fixedScreen ? 'Collapse Size' : 'Expand Size'"
            @click="$emit('toggle-width')">
        <i class="fas" :class="fixedScreen ? 'fa-solid fa-expand' : 'fa-solid fa-compress'"></i>
      </span>

      <span @click="$emit('toggle-body')" :title="isCollapsed ? 'Expand' : 'Collapse'">
        <i class="fas" :class="isCollapsed ? 'fa-caret-square-down' : 'fa-caret-square-up'"></i>
      </span>

      <span v-for="(ai,index) in currentMenuActionIconsData" :key="'d-'+index">
        <span @click="$emit('action', ai.functionName, index, ai)">
          <i :id="ai.iconId"
             :class="[iconOnChangeFlag[index] === true ? ai.iconClass : ai.iconOnchangeClass]"
             :title="iconOnChangeFlag[index] ? ai.iconTooltip : ai.iconOnchangeTooltip"
             style="font-size:15px; padding-left:10px;"></i>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VizletHeader',
  props: {
    viz1: { type: Object, required: true },
    currentMenuActionIconsData: { type: Array, default: () => [] },
    mCurrentMenuActionIconsData: { type: Array, default: () => [] },
    vizCount: { type: Number, default: 1 },
    searchQuery: { type: String, default: '' },
    iconOnChangeFlag: { type: Array, default: () => [] },
    isCollapsed: { type: Boolean, default: false },
    format: { type: Function, default: v => v },
    total: { type: [String, Number], default: '' }
  },
  data() {
    return {
      localSearchQuery: this.searchQuery || ''
    }
  },
  watch: {
    searchQuery(newVal) {
      this.localSearchQuery = newVal;
    }
  },
  computed: {
    fixedScreen() {
      return this.$store.state.fixedScreen;
    }
  },
  methods: {
    showTooltip() {
      // bootstrap-vue tooltip show
      const tooltip = this.$refs.tooltipIcon && this.$refs.tooltipIcon._tooltip;
      if (tooltip && tooltip.show) tooltip.show();
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon && this.$refs.tooltipIcon._tooltip;
      if (tooltip && tooltip.hide) tooltip.hide();
    },
    handleSearchInput() {
      const q = this.localSearchQuery;
      // emit search (parent components listen & do the work)
      this.$emit('search', q);
      // support v-model / .sync
      this.$emit('update:searchQuery', q);
    }
  }
}
</script>

<style scoped>
/* optional header styles */
</style>
